module.exports = __webpack_public_path__ + "img/BRCA2_Endothelial.b526d3bc.png";